import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, Link, useParams } from "react-router-dom";

// Backend
import { getInvoice, getVehicleFullList } from "connection/backend";

// actions
import { invoiceUpdate } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const DepartureUpdate = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const redirect = () => {
    history.push("/departures");
  };

  const getVehicleData = async () => {
    const response = await getVehicleFullList();
    const data = response.data;
    setVehicles(data);
  };

  const getData = async (id) => {
    const response = await getInvoice(id);
    const data = response.data;
    setDetails({
      ticket: data.client_data.ticket,
      client_code: data.client_data.client_code,
      client_name: data.client_data.client_name,
      animal_number: data.client_data.animal_number,
      plant_name: data.plant_name,
      invima_code: data.invima_code,
      department: data.department,
      city: data.city,
      address: data.address,
      destination_department: data.destination_department,
      destination_city: data.destination_city,
      destination_address: data.destination_address,
      sacrifice_date: data.created_date,
      expedition_date: data.expedition_date,
      destination_establishment: data.destination_establishment,
      temperature: data.temperature,
      batch: data.batch,
      dispatch_time: data.dispatch_time,
      vehicle: data.vehicle,
      species: data.species,
      state: data.state,
      responsible: data.responsible,
    });
    setProducts({
      product_1: data.product_list[0].name,
      units_1: data.product_list[0].units,
      weight_1: data.product_list[0].weight,
      product_2: data.product_list[1].name,
      units_2: data.product_list[1].units,
      weight_2: data.product_list[1].weight,
      product_3: data.product_list[2].name,
      units_3: data.product_list[2].units,
      weight_3: data.product_list[2].weight,
      product_4: data.product_list[3].name,
      units_4: data.product_list[3].units,
      weight_4: data.product_list[3].weight,
      product_5: data.product_list[4].name,
      units_5: data.product_list[4].units,
      weight_5: data.product_list[4].weight,
      product_6: data.product_list[5].name,
      units_6: data.product_list[5].units,
      weight_6: data.product_list[5].weight,
      product_7: data.product_list[6].name,
      units_7: data.product_list[6].units,
      weight_7: data.product_list[6].weight,
      product_8: data.product_list[7].name,
      units_8: data.product_list[7].units,
      weight_8: data.product_list[7].weight,
    });
  };

  useEffect(() => {
    getVehicleData();
    getData(id);
  }, []);

  const [vehicles, setVehicles] = useState([]);

  const [details, setDetails] = useState({
    ticket: "",
    client_code: "",
    client_name: "",
    animal_number: 0,
    plant_name: "",
    invima_code: "",
    department: "",
    city: "",
    address: "",
    destination_department: "",
    destination_city: "",
    destination_address: "",
    sacrifice_date: "",
    expedition_date: "",
    destination_establishment: "",
    temperature: 0,
    batch: "",
    dispatch_time: "",
    vehicle: "",
    species: "",
    state: "",
    responsible: "",
    observations: "",
  });

  const {
    ticket,
    client_code,
    client_name,
    animal_number,
    plant_name,
    invima_code,
    department,
    city,
    address,
    destination_department,
    destination_city,
    destination_address,
    sacrifice_date,
    expedition_date,
    destination_establishment,
    temperature,
    batch,
    dispatch_time,
    vehicle,
    species,
    state,
    responsible,
    observations,
  } = details;

  const [products, setProducts] = useState({
    product_1: "",
    units_1: 0,
    weight_1: 0,
    product_2: "",
    units_2: 0,
    weight_2: 0,
    product_3: "",
    units_3: 0,
    weight_3: 0,
    product_4: "",
    units_4: 0,
    weight_4: 0,
    product_5: "",
    units_5: 0,
    weight_5: 0,
    product_6: "",
    units_6: 0,
    weight_6: 0,
    product_7: "",
    units_7: 0,
    weight_7: 0,
    product_8: "",
    units_8: 0,
    weight_8: 0,
  });

  const {
    product_1,
    units_1,
    weight_1,
    product_2,
    units_2,
    weight_2,
    product_3,
    units_3,
    weight_3,
    product_4,
    units_4,
    weight_4,
    product_5,
    units_5,
    weight_5,
    product_6,
    units_6,
    weight_6,
    product_7,
    units_7,
    weight_7,
    product_8,
    units_8,
    weight_8,
  } = products;

  const onChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  const onChange1 = (e) => {
    setProducts({ ...products, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let data = {
      destination_establishment: destination_establishment,
      destination_department: destination_department,
      destination_city: destination_city,
      destination_address: destination_address,
      expedition_date: expedition_date,
      sacrifice_date: sacrifice_date,
      state: state,
      temperature: temperature,
      observations: observations ? observations : "",
      dispatch_time: dispatch_time,
      vehicle: vehicle,
      responsible: responsible,
      product_list: [
        {
          name: product_1,
          units: parseInt(units_1),
          weight: parseInt(weight_1),
        },
        {
          name: product_2,
          units: parseInt(units_2),
          weight: parseInt(weight_2),
        },
        {
          name: product_3,
          units: parseInt(units_3),
          weight: parseInt(weight_3),
        },
        {
          name: product_4,
          units: parseInt(units_4),
          weight: parseInt(weight_4),
        },
        {
          name: product_5,
          units: parseInt(units_5),
          weight: parseInt(weight_5),
        },
        {
          name: product_6,
          units: parseInt(units_6),
          weight: parseInt(weight_6),
        },
        {
          name: product_7,
          units: parseInt(units_7),
          weight: parseInt(weight_7),
        },
        {
          name: product_8,
          units: parseInt(units_8),
          weight: parseInt(weight_8),
        },
      ],
    };
    dispatch(invoiceUpdate(id, data));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Autorizaciones </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Autorizaciones"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.invoiceUpdated.number ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  La autorización se ha actualizado correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "100rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">
                    Actualizar Autorización Invima
                  </h2>
                </CardTitle>
                <CardBody>
                  <Row className="justify-content-md-center">
                    <Col lg={2}>
                      <label>
                        <b>Ticket:</b> {ticket}
                      </label>
                    </Col>
                    <Col lg={2}>
                      <label>
                        <b>Cliente:</b> {client_code}
                      </label>
                    </Col>
                    <Col lg={4}>
                      <label>
                        <b>Nombre:</b> {client_name}
                      </label>
                    </Col>
                    <Col lg={1}>
                      <label>
                        <b>Bovinos:</b> {animal_number}
                      </label>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col lg={9}>
                      <hr />
                    </Col>
                  </Row>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={6}>
                        <Label for="plant_name">
                          <b>Nombre:</b>
                        </Label>
                        <Input
                          id="plant_name"
                          name="plant_name"
                          type="text"
                          value={plant_name}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={3}>
                        <Label for="invima_code">
                          <b>Código INVIMA:</b>
                        </Label>
                        <Input
                          id="invima_code"
                          name="invima_code"
                          type="text"
                          value={invima_code}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Label for="department">
                          <b>Departamento:</b>
                        </Label>
                        <Input
                          id="department"
                          name="department"
                          type="text"
                          value={department}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={3}>
                        <Label for="city">
                          <b>Ciudad ó Municipio:</b>
                        </Label>
                        <Input
                          id="city"
                          name="city"
                          type="text"
                          value={city}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={3}>
                        <Label for="address">
                          <b>Dirección:</b>
                        </Label>
                        <Input
                          id="address"
                          name="address"
                          type="text"
                          value={address}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-2">
                      <Col lg={9}>
                        <hr />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <Label for="destination_city">
                          <b>Municipio:</b>
                        </Label>
                        <Input
                          id="destination_city"
                          name="destination_city"
                          type="text"
                          value={destination_city}
                          onChange={onChange}
                        />
                      </Col>
                      <Col lg={3}>
                        <Label for="destination_department">
                          <b>Departamento:</b>
                        </Label>
                        <Input
                          id="destination_department"
                          name="destination_department"
                          type="text"
                          value={destination_department}
                          onChange={onChange}
                        />
                      </Col>
                      <Col lg={3}>
                        <Label for="destination_address">
                          <b>Dirección:</b>
                        </Label>
                        <Input
                          id="destination_address"
                          name="destination_address"
                          type="text"
                          value={destination_address}
                          onChange={onChange}
                        />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-2">
                      <Col lg={9}>
                        <hr />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <Label>
                          <b>PRODUCTO:</b>
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <Label>
                          <b>ESPECIE:</b>
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <Label>
                          <b>UNIDADES:</b>
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <Label>
                          <b>PESO (kg):</b>
                        </Label>
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-1">
                      <Col lg={3}>
                        <Input
                          id="product_1"
                          name="product_1"
                          type="text"
                          value={product_1}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="species"
                          name="species"
                          type="text"
                          value={species}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="units_1"
                          name="units_1"
                          type="number"
                          min={0}
                          value={units_1}
                          onChange={onChange1}
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="weight_1"
                          name="weight_1"
                          type="number"
                          min={0}
                          value={weight_1}
                          onChange={onChange1}
                        />
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Input
                          id="product_2"
                          name="product_2"
                          type="text"
                          value={product_2}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="species"
                          name="species"
                          type="text"
                          value={species}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="units_2"
                          name="units_2"
                          type="number"
                          value={units_2}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="weight_2"
                          name="weight_2"
                          type="number"
                          value={weight_2}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Input
                          id="product_4"
                          name="product_4"
                          type="text"
                          value={product_4}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="species"
                          name="species"
                          type="text"
                          value={species}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="units_4"
                          name="units_4"
                          type="number"
                          value={units_4}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="weight_4"
                          name="weight_4"
                          type="number"
                          value={weight_4}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-2">
                      <Col lg={9}>
                        <hr />
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <Label>
                          <b>PRODUCTO:</b>
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <Label>
                          <b>ESPECIE:</b>
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <Label>
                          <b>UNIDADES:</b>
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <Label>
                          <b>PESO (kg):</b>
                        </Label>
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Input
                          id="product_3"
                          name="product_3"
                          type="text"
                          value={product_3}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="species"
                          name="species"
                          type="text"
                          value={species}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="units_3"
                          name="units_3"
                          type="number"
                          value={units_3}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="weight_3"
                          name="weight_3"
                          type="number"
                          value={weight_3}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Input
                          id="product_5"
                          name="product_5"
                          type="text"
                          value={product_5}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="species"
                          name="species"
                          type="text"
                          value={species}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="units_5"
                          name="units_5"
                          type="number"
                          value={units_5}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="weight_5"
                          name="weight_5"
                          type="number"
                          value={weight_5}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Input
                          id="product_6"
                          name="product_6"
                          type="text"
                          value={product_6}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="species"
                          name="species"
                          type="text"
                          value={species}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="units_6"
                          name="units_6"
                          type="number"
                          value={units_6}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="weight_6"
                          name="weight_6"
                          type="number"
                          value={weight_6}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Input
                          id="product_7"
                          name="product_7"
                          type="text"
                          value={product_7}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="species"
                          name="species"
                          type="text"
                          value={species}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="units_7"
                          name="units_7"
                          type="number"
                          value={units_7}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="weight_7"
                          name="weight_7"
                          type="number"
                          value={weight_7}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                    </Row>

                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Input
                          id="product_8"
                          name="product_8"
                          type="text"
                          value={product_8}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="species"
                          name="species"
                          type="text"
                          value={species}
                          onChange={onChange1}
                          disabled
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="units_8"
                          name="units_8"
                          type="number"
                          value={units_8}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                      <Col lg={2}>
                        <Input
                          id="weight_8"
                          name="weight_8"
                          type="number"
                          value={weight_8}
                          min={0}
                          onChange={onChange1}
                        />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-2">
                      <Col lg={9}>
                        <hr />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <Label for="sacrifice_date">
                          <b>Fecha de sacrificio:</b>
                        </Label>
                        <Input
                          id="sacrifice_date"
                          name="sacrifice_date"
                          type="date"
                          value={sacrifice_date}
                          onChange={onChange}
                        />
                      </Col>
                      <Col lg={3}>
                        <Label for="expedition_date">
                          <b>Fecha de expedición:</b>
                        </Label>
                        <Input
                          id="expedition_date"
                          name="expedition_date"
                          type="date"
                          value={expedition_date}
                          onChange={onChange}
                        />
                      </Col>
                      <Col lg={3}>
                        <Label for="destination_establishment">
                          <b>Establecimiento de destino:</b>
                        </Label>
                        <Input
                          id="destination_establishment"
                          name="destination_establishment"
                          type="text"
                          value={destination_establishment}
                          onChange={onChange}
                        />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-2">
                      <Col lg={3}>
                        <Label for="state">
                          <b>Estado:</b>
                        </Label>
                        <Input
                          id="state"
                          name="state"
                          type="select"
                          value={state}
                          onChange={onChange}
                        >
                          <option value="aprobado">Aprobado</option>
                          <option value="aprobado_condicionado">
                            Aprobado condicionado
                          </option>
                        </Input>
                      </Col>
                      <Col lg={3}>
                        <Label for="temperature">
                          <b>Temperatura promedio:</b>
                        </Label>
                        <Input
                          id="temperature"
                          name="temperature"
                          type="number"
                          value={temperature}
                          onChange={onChange}
                        />
                      </Col>
                      <Col lg={3}>
                        <Label for="batch">
                          <b>Lote:</b>
                        </Label>
                        <Input
                          id="batch"
                          name="batch"
                          type="text"
                          value={batch}
                          onChange={onChange}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-2">
                      <Col lg={9}>
                        <Label for="observations">
                          <b>Observaciones:</b>
                        </Label>
                        <Input
                          id="observations"
                          name="observations"
                          placeholder="Ingresa alguna observación"
                          type="textarea"
                          value={observations}
                          onChange={onChange}
                        />
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-2">
                      <Col lg={2}>
                        <Label for="dispatch_time">
                          <b>Hora de despacho:</b>
                        </Label>
                        <Input
                          id="dispatch_time"
                          name="dispatch_time"
                          type="time"
                          value={dispatch_time}
                          onChange={onChange}
                        />
                      </Col>
                      <Col lg={4}>
                        <Label for="vehicle">
                          <b>Vehículo:</b>
                        </Label>
                        <Input
                          id="vehicle"
                          name="vehicle"
                          type="select"
                          value={vehicle}
                          onChange={onChange}
                        >
                          <option defaultValue value="">
                            -----
                          </option>
                          {vehicles.map((vehicle, idx) => (
                            <option
                              key={idx}
                              value={vehicle.id}
                            >{`${vehicle.plate} - ${vehicle.driver}`}</option>
                          ))}
                        </Input>
                      </Col>
                      <Col lg={3}>
                        <Label for="responsible">
                          <b>Responsable:</b>
                        </Label>
                        <Input
                          id="responsible"
                          name="responsible"
                          type="select"
                          value={responsible}
                          onChange={onChange}
                        >
                          <option value="persona_1" defaultValue>
                            Doris Yohana Melo Garzón
                          </option>
                          <option value="persona_2">
                            Javier Alonso Chavarro Chavarro
                          </option>
                        </Input>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-3" align="center">
                        <Link className="btn btn-danger me-4" to="/departures">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Actualizar autorización
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, invoiceUpdated } = state.Billing;
  return { error, loading, invoiceUpdated };
};

export default withRouter(connect(mapStateToProps)(DepartureUpdate));
